import { render, staticRenderFns } from "./ClientDeleteDialog.vue?vue&type=template&id=31173b01&scoped=true&"
import script from "./ClientDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ClientDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31173b01",
  null
  
)

export default component.exports